export const INTERNAL_ERROR_CODE = {
  FAILED: -3,
  UNKNOWN: -2,
  PENDING: -1,
  OK: 0,
};

export const INTERNAL_ERROR_CODE_TEXT = {
  [INTERNAL_ERROR_CODE.FAILED]: `${INTERNAL_ERROR_CODE.FAILED} - Falla en la request`,
};

export const HIDDEN_ERROR_CODES = [INTERNAL_ERROR_CODE.OK, INTERNAL_ERROR_CODE.PENDING];
